import * as Sentry from '@sentry/react';

const {
  VITE_SENTRY_DSN,
  VITE_SENTRY_TUNNEL_SERVICE,
  VITE_SENTRY_SAMPLE_RATE,
  // VITE_SENTRY_REPLAY_SAMPLE_RATE,
  // VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE,
} = import.meta.env;

// Regex pattern for asset file extensions to avoid duplication
const ASSET_FILE_REGEX =
  /\.(js|css|png|jpg|jpeg|gif|svg|woff|woff2|ttf|eot|ico)$/i;

// Helper function to check if a URL/transaction is an asset
const isAssetRequest = (url: string): boolean => {
  return (
    ASSET_FILE_REGEX.test(url) ||
    url.includes('/assets/') ||
    url.includes('/static/') ||
    url.includes('node_modules')
  );
};

if (VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: VITE_SENTRY_DSN,
    tunnel: VITE_SENTRY_TUNNEL_SERVICE,
    integrations: [
      Sentry.browserTracingIntegration({
        // Only trace specific routes that matter for performance monitoring
        shouldCreateSpanForRequest: (url) => {
          // Ignore asset requests, static assets, and vendor files
          if (isAssetRequest(url)) {
            return false;
          }

          // Only trace API calls
          return url.includes('/api/');
        },
      }),
      // Sentry.replayIntegration(),
    ],

    // Reduce trace sample rate to further limit span creation
    // Parse as float with a much lower default (0.5 = 50% of transactions)
    // Set to 0.1 (10%) or lower in production to control volume if we reach limits
    tracesSampleRate: parseFloat(VITE_SENTRY_SAMPLE_RATE) || 0.5,

    // Filter out transactions for asset loading and unimportant routes
    beforeSendTransaction(event) {
      const transactionName = event.transaction;

      if (transactionName && isAssetRequest(transactionName)) {
        return null;
      }

      return event;
    },

    // Capture Replay for 10% of all sessions, plus for 100% of sessions with an error as recommended by Sentry
    /* replaysSessionSampleRate: parseFloat(VITE_SENTRY_REPLAY_SAMPLE_RATE) || 0.1,
    replaysOnErrorSampleRate:
      parseFloat(VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE) || 1.0, */
  });
}
